import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import ethimg from "../../images/chainpad/eth.png.png";
import CopyToClipboard from "react-copy-to-clipboard";
import toast, { Toaster } from 'react-hot-toast';
import ReactPlayer from 'react-player';
import { FaThumbsUp, FaThumbsDown } from 'react-icons/fa';
import { padToDigits } from "../../helper/timeFormat"
import Likemodal from "../likenotificationmodal";
import { iconTheme, position, style } from "../../hooks/useToast";
import Header from '../Header';
import Sidebar from '../Sidebar';
import Trendingslider from '../trendingslider';
import { getAccount, getAllocationInfo, getChainId } from '../../hooks/useAccount'
import Chart from "react-apexcharts";
import Countdown from 'react-countdown';
import { Container, ProgressBar, InputGroup, FormControl, Button } from 'react-bootstrap';
import '../../css/styles.css';
import favicon from "../../images/chainpad/logo.png"
import isEmpty from 'is-empty';
import { withRouter } from 'react-router-dom';
import logo1 from "../../images/chainpad/PancakeSwap.png";
import logo2 from "../../images/chainpad/Poocoin.png";
import logo3 from "../../images/chainpad/DexCheck.png";
import logo4 from "../../images/chainpad/ave-ai.ico";
import logo5 from "../../images/chainpad/geckoTerminal.webp";
import logo6 from "../../images/chainpad/QuickIntel.png";


import { Link } from 'react-router-dom';
import WhitelistModal from "../WhitelistModal"
import RemoveWhitelistmodal from "../RemoveWhitelistmodal"
import ChangeStatusmodal from "../ChangeStatusmodal"
import { approveContractbuy, checkIsApproved, Getliquiditytokenamount, Getsalebalance, getSaleInfoCard, GetSalePerAccount, Getunsoldtoken, UseTokenInfo, getAffliateInfo, UsegetChildrenOf, getProxyOwner, checkNativeTokens } from '../../hooks/useContract';
import { isSaleLive, isUpcoming, Salediffernce, UpcomingDiffernce } from '../../hooks/useProjects';
import { ONEDAYINSECONDS, AdminTokenAddress, ZEROTH_ADDRESS } from '../../config/env';
import { BuyToken, calculateBuy, claimToken } from '../../hooks/useBuy';
import { Finalise, getUnsold, SetWhitelisted, updateStopEvent, withdrawBNB } from '../../hooks/useAdmin';
import { getallsalehook, gettrendingdisplayhook, SaleLike, getSaleLikes, getuserdatahook } from '../../hooks/usebackend';
import detailbanner from '../../images/chainpad/detailbanner.gif.png';
import { CHAINS, frontendurl } from "../../config/env";
import { daysCalculation } from "../../helper/weekCal";

const renderer = ({ days, Month, Year, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <div className='cout_man_div'>
      <div>{days}d </div>
      <div>{hours}h</div>
      <div>{minutes}m</div>
      <div>{seconds}s </div>
    </div>
  } else {
    // Render a countdown
    return <div className='cout_man_div'>
      {/* <span>{days}<span>Days</span> </span>
                <span>{hours}<span>Hours</span></span>
                <span>{minutes}<span>Minuits</span></span>   
                <span>{seconds}<span>Seconds</span> </span>    */}
      <div>{days}d </div>
      <div>{hours}h</div>
      <div>{minutes}m</div>
      <div>{seconds}s </div>
    </div>;
  }
};


class PrivatesaleDetail extends Component {
  showLoader() {
    document.getElementsByTagName("body")[0].classList.add("overflow_hidden");
    document.getElementById("logo_overlay").style.opacity = 0.05;
    document.getElementById("loader_div").classList.remove("d-none");
    document.getElementById("loader_div").classList.add("d-block");


  }

  hideLoader() {
    document.getElementsByTagName("body")[0].classList.remove("overflow_hidden");
    document.getElementById("logo_overlay").style.opacity = 1;
    document.getElementById("loader_div").classList.remove("d-block");
    document.getElementById("loader_div").classList.add("d-none");



  }

  componentDidMount() {
    document.getElementById("home_grad_aprent").classList.remove("active");
    document.getElementById("privatesale_parent").classList.add("active");
    // this.showLoader();
    // this.hideLoader();
    //  this.setState({ accountInfo: getAccount() });
    this.gettrending();
    this.handlegetkyc()
    this.refreshData()
    this.getLike()
    this.tokenInfo()
    this.getuserdata()
  }


     handleGoBack = () => {
    this.props.history.goBack();
  };

  numberChange(data) {
    try {
        return (isNaN(Number(data)) ? 0 : Number(data))
    }
    catch (err) {
        console.log('numberChange_error', err)
        return 0;
    }
  }


  async getLike() {
    console.log("sdgsdfs")
    let likecount = await getSaleLikes(this.state.saleAddress)
    if (likecount?.data?.type !== "failure") {
      console.log("likecount", likecount, this.state.saleAddress)
      this.setState({ likeCount: likecount?.data?.data?.like, dislikeCount: likecount?.data?.data?.dislike })
    }
  }


  async tokenInfo() {
    const token = await UseTokenInfo(AdminTokenAddress);
    console.log(token, "tokeninfo_launchList")
    this.setState({ admintokeninfo: token });
    console.log(this.state.admintokeninfo, "tokeninfo_")
    var balance = await checkNativeTokens(getAccount(), AdminTokenAddress)
    console.log("balance", localStorage.getItem("accountInfo"), parseFloat(balance / 10 ** (token.decimals)))
    this.setState({ tokenBalance: parseFloat(balance / 10 ** (token.decimals)) })
    console.log("tokenBalance", this.state.tokenBalance)
  }


  getuserdata = async () => {
    try {


      let userdata = await getuserdatahook(this.state.accountInfo.toLowerCase());
      console.log("userdata1_private", userdata?.data?.data, this.state.saleAddress);


      this.setState({ wishlist: userdata?.data?.data?.wishlist })

      let likes = userdata?.data?.data?.likes
      likes?.length > 0 && likes?.map((val) => {
        if (val.saleaddress == this.state.saleAddress) {
          this.setState({ islike: val?.islike })
        }
      })


    }
    catch (err) {
      console.log("err_getuserdata", err)
    }

  }


  handlegetkyc = async () => {
    let auditkycinfo = await getallsalehook();
    if (auditkycinfo?.data?.data?.length > 0) {
      this.setState({ auditkyc: auditkycinfo?.data?.data })
    }

    let singleaudit = auditkycinfo?.data?.data?.find(e => e.saleaddress == window.location.pathname.split('/')[2])
    console.log("auditkuycinfo", auditkycinfo?.data?.data, singleaudit);

    if (singleaudit)
      this.setState({ singleaudit: singleaudit })
  }
  async gettrending() {
    const { saleData } = this.props
    let data = await gettrendingdisplayhook();
    console.log("dataa trending", data?.data?.data);
    if (data?.data?.data?.length > 0)
      this.setState({ trending: data?.data?.data })
    let finddata = data?.data?.data?.find((e) => e?.saleaddress == this.state.saleAddress)
    this.setState({ singletrending: finddata })
  }


  constructor(props) {
    super(props);
    this.state = {
      walletModal: false,
      saleAddress: window.location.pathname.split('/')[2],
      accountInfo: '',
      series: [44, 55, 41, 17, 15],
      options: {
        labels: ["Total Tokens", "Sold Tokens", "Unsold Tokens", "Liquidity Tokens"],
        chart: {
          type: 'donut',
        },
          stroke: {
    show: false,   
    width: 0,      
  },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 270
              },
              legend: {
                position: 'top'
              }
            },
          },
          {
            breakpoint: 600,
            options: {
              chart: {
                width: 350
              },
              legend: {
                position: 'top'
              }
            }
          },
          {
            breakpoint: 768,
            options: {
              chart: {
                width: 300
              },
              legend: {
                position: 'top'
              }
            }
          },
          {
            breakpoint: 900,
            options: {
              chart: {
                width: 320
              },
              legend: {
                position: 'top'
              }
            }
          },
          {
            breakpoint: 1199,
            options: {
              chart: {
                width: 330
              },
              legend: {
                position: 'top'
              }
            }
          },
          {
            breakpoint: 1250,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: 'top'
              }
            }
          },
          {
            breakpoint: 2000,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: 'top'
              }
            }
          },
          {
            breakpoint: 10000,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: 'top'
              }
            }
          }
        ]
      },
      iswhitelisted: true,
      whitelistModal: false,
      removewhitelistModal: false,
      changestatueModal: false,
      buyToken: "",
      saleInfo: {},
      userData: {},
      allocations: [],
      buyTokenDecimal: 18,
      amount: 0,
      claim: 0,
      max: 0,
      isMax: false,
      liqtoken: "",
      unsoldtoken: "",
      chartstatus: false,
      charttokendecimal: "",
      trending: [],
      singletrending: {},
      approvebutton: false,
      auditkyc: [],
      singleaudit: {},
      lpUnlockon: "",
      AffliateInfo: {},
      getChildren: [],
      tokeninfo: {},
      like: 0,
      dislike: 0,
      islike: null,
      likeCount: 0,
      dislikeCount: 0,
      likeStart: false,
      dislikeStart: false,
      admintokeninfo: {},
      tokenBalance: 0,
      wishlist: [],
      accountInfo: getAccount(),
      isSaleEnd: false,
      likenotfiModal: false,
    };
  }

  handlewithdraw = async () => {
    let account = getAccount();
    let withdraw = await withdrawBNB(this.state.saleAddress, account);
  }

  approveFunction = async (accountInfo, tokenAddress, saleAddress) => {
    const approval = await checkIsApproved(accountInfo, tokenAddress, saleAddress);
    console.log("approval0", approval);
    this.setState({ approvebutton: approval })


  }


  async approvetoken() {
    await approveContractbuy(localStorage.getItem("accountInfo"), this.state.saleInfo.useWithToken, this.state.saleAddress);
    this.setState({ approvebutton: true })
  }

  loadData = async () => {
    this.showLoader();
    // if(window.location.pathname.split('/')[3] || window.location.pathname.split('/')[3] == "true"){
    //   console.log("db");
    //   let saleDetail =  JSON.parse(localStorage.getItem("saledata"))
    //   this.setState({ saleInfo: saleDetail});
    // }
    // else{
    const saleDetail = await getSaleInfoCard(this.state.saleAddress);
    var saleData = { ...saleDetail }
    saleData.presaleRate = saleData.presaleRate / 10 ** 18
    saleData.pancakeRate = saleData.pancakeRate / 10 ** 18
    this.setState({ saleInfo: saleData });
    if (localStorage.getItem("accountInfo")) {
      const user = await GetSalePerAccount(localStorage.getItem("accountInfo"), this.state.saleAddress);
      this.setState({ userData: user });

      if (saleDetail.isClaimable) {
        const allocated = await getAllocationInfo(user.actualBalance, user.userClaimbale, saleDetail.vestingInterval, saleDetail.vestingPercent, user.initialClaim);
        this.setState({ allocations: allocated });
        console.log("allcations L ", allocated)
      }

      if (!saleDetail?.buytype) {
        this.approveFunction(localStorage.getItem("accountInfo"), saleDetail?.useWithToken, saleDetail?.saleAddress)
      }
    }
    // }
    this.hideLoader();
  }

  refreshData = async () => {
    this.showLoader();
    //  if(window.location.pathname.split('/')[3] || window.location.pathname.split('/')[3] == "true"){
    //   console.log("db");
    //   let saleDetail =  JSON.parse(localStorage.getItem("saledata"))
    //   this.setState({ saleInfo: saleDetail});
    // }
    // else{
    console.log("address", this.state.saleAddress);
    const saleDetail = await getSaleInfoCard(this.state.saleAddress);
    console.log("saledetail", saleDetail);

    console.log("saleDetail", saleDetail);

    const AffliateInfo = await getAffliateInfo(this.state.saleAddress);
    console.log("AffliateInfo", AffliateInfo)
    this.setState({ AffliateInfo: AffliateInfo })


    const getChildrendata = await UsegetChildrenOf(this.state.saleAddress, getAccount());
    this.setState({ getChildren: getChildrendata })
    console.log("getChildrengetChildren", getChildrendata, getChildrendata?.length);


    const token = await UseTokenInfo(saleDetail?.tokenAddress);
    let decimal;
    console.log("tokentokentoken", token);
    this.setState({ tokeninfo: token })
    this.setState({ charttokendecimal: 18 })
    let liqtoken = await Getliquiditytokenamount(this.state.saleAddress);
    console.log("liqtoken", liqtoken);

    this.setState({ "liqtoken": liqtoken / 10 ** 18 })
    let unsoldtoken = await Getunsoldtoken(this.state.saleAddress);
    console.log("liqtoken", liqtoken);
    this.setState({ unsoldtoken: unsoldtoken / 10 ** 18 });
    var saleData = { ...saleDetail }
    saleData.presaleRate = saleData.presaleRate / 10 ** 18
    saleData.pancakeRate = saleData.pancakeRate / 10 ** 18
    this.setState({ saleInfo: saleData });

    let saleEnd = isSaleLive(saleDetail.startTime, saleDetail.endTime, saleDetail.isPresaleOpen)
    console.log("saleEnd", saleEnd)
    this.setState({ isSaleEnd: saleEnd });
    this.setState({ "chartstatus": true });
    this.GetBuytokeninfo(saleDetail?.useWithToken)

    if (localStorage.getItem("accountInfo")) {
      const user = await GetSalePerAccount(localStorage.getItem("accountInfo"), this.state.saleAddress);
      console.log("user", user);
      this.setState({ userData: user });
      if (saleDetail?.isClaimable) {
        const allocated = await getAllocationInfo(user?.actualBalance, saleDetail?.vestingInterval, saleDetail?.vestingPercent, user?.initialClaim);
        this.setState({ allocations: allocated });
      }

      if (!saleDetail?.buytype) {
        this.approveFunction(localStorage.getItem("accountInfo"), saleDetail?.useWithToken, saleDetail?.saleAddress)
      }

    }
    // }

    this.hideLoader()
  }

  GetBuytokeninfo = async (value) => {

    if (value === "0x0000000000000000000000000000000000000000") {
      console.log("kxcnvjxch");
      this.setState({ buyToken: "LUMINA" });
      this.setState({ buyTokenDecimal: 18 })
    } else {
      const token = await UseTokenInfo(this.state.saleInfo && this.state.saleInfo?.useWithToken);
      console.log("UseTokenInfo", token);
      this.setState({ buyToken: token?.symbol });
      this.setState({ buyTokenDecimal: Number(token?.decimals) })

    }
  }

  async max() {
    this.setState({ max: this.state.saleInfo && (parseInt(this.state.saleInfo?.maxEthLimit) / 10 ** this.state.buyTokenDecimal), isMax: true })
    this.setState({ amount: this.state.saleInfo && (parseInt(this.state.saleInfo?.maxEthLimit) / 10 ** this.state.buyTokenDecimal) })

  }

  hidewithdraw = async () => {
    var balance = Getsalebalance(this.state.saleAddress, this.state?.saleInfo?.isWithoutToken);
    if (balance > 0) {
      return false
    }
    else {
      return true
    }
  }


  //   async calculateToken(value){

  //     const tokenValue = await calculateBuy(this.state.saleAddress,value);
  //     this.setState({ claim: (tokenValue/10**this.state.saleInfo?.decimals) })

  // }

  // async calculateToken(value){console.log("calculate claim");
  //     if(this.state.saleInfo.useWithToken == "0x0000000000000000000000000000000000000000"){
  //       const tokenValue = await calculateBuy(this.state.saleAddress,value);
  //       console.log("calculate claim in bnb" , tokenValue , this.state.saleInfo.decimals);
  //       this.setState({ claim: (tokenValue/10**18) })
  //       this.setState({isMax : false}) 
  //     }
  //     else{
  //         let tokeninfo = await UseTokenInfo(this.state.saleInfo.useWithToken)
  //         const tokenValue = await calculateBuy(this.state.saleAddress,value);
  //         console.log("calculate claim token" , tokenValue , tokeninfo?.decimals);
  //         this.setState({ claim: (tokenValue/10**tokeninfo?.decimals).toFixed(2) });
  //         this.setState({isMax : false}) 
  //     }
  // }

  async calculateToken(value) {
    console.log("maxEthLimit", this.state.saleInfo?.maxEthLimit)
    const tokenValue = await calculateBuy(this.state.saleAddress, value);
    this.setState({ claim: (tokenValue / 10 ** this.state.saleInfo?.decimals) })
    this.setState({ isMax: false })
  }


  // async buy() {
  //   console.log("buyyyyyyyyyyyyyyyyyyyyyyy");
  //   await BuyToken(this.state.saleAddress, this.state.amount, this.state.isMax, this.state.max, getAccount(), this.state.buyTokenDecimal, this.state.buyToken);
  //   window.location.reload();
  //   // this.reset();
  //   // this.props.onUpdate();
  // }
  async buy() {
    console.log("buyyyyyyyyyyyyyyyyyyyyyyy");
    const owner = await getProxyOwner();
    const afflink = window.location.pathname.split('/')[3];
    var AffLink = (afflink?.length != 42 || afflink == "" || afflink == undefined) ? ZEROTH_ADDRESS : afflink;
    await BuyToken(this.state.saleAddress, this.state.amount, this.state.isMax, this.state.max, getAccount(), this.state.buyTokenDecimal, AffLink, this.state.saleInfo.tokenAddress, parseFloat(this.state.AffliateInfo[0]) / 10 ** 18, this?.state?.tokeninfo?.symbol)

    // await BuyToken(this.state.saleAddress,this.state.amount,this.state.isMax,this.state.max,getAccount(),this.state.buyTokenDecimal,AffLink);

    window.location.reload();
    // this.reset();
    // this.props.onUpdate();
  }


  async Claim() {
    await claimToken(this.state.saleAddress, getAccount());
    // this.props.onUpdate();
  }

  async stopSaleEvent() {
    await updateStopEvent(this.state.saleAddress, getAccount());
    await this.refreshData()

  }



  async withdrawToken() {
    await getUnsold(this.state.saleAddress, getAccount());
    await this.refreshData()
      ;
  }

  async BNBwithdraw() {
    await withdrawBNB(this.state.saleAddress, getAccount());
    await this.refreshData()

  }

  async Finalisesale() {
    await Finalise(this.state.saleAddress, getAccount());
    await this.refreshData()

  }

  async Handlewhitelist(value) {
    await SetWhitelisted(this.state.saleAddress, value, getAccount());
    await this.refreshData()
  }

  async unlockOn() {
    console.log(this.state.saleInfo.lpUnlockon, "lpUnlockon")
    var unlock = daysCalculation(this.state.saleInfo.lpUnlockon)
    this.setState({ lpUnlockon: unlock })
  }

  async copyCode(a, b) {
    toast.success("Affliate link Copied", {
      position: position.position,
      style: style,
      iconTheme: iconTheme,
    })
  }


  async hadleLike() {
    this.setState({ like: 1 })
    let account = getAccount();
    this.setState({ likeStart: !this.state.likeStart })
    this.setState({ dislikeStart: false })

    let data = {
      saleaddress: this.state.saleAddress,
      walletaddress: account.toLowerCase(),
      like: 1,
      dislike: 0
    }
    var sales = await SaleLike(data)
    console.log("likesales", sales)
    let likes = sales?.data?.user?.likes
    likes?.map((val) => {
      if (val.saleaddress == this.state.saleAddress) {
        this.setState({ islike: val.islike, likeCount: sales?.data?.result?.like, dislikeCount: sales?.data?.result?.dislike })
      }
    })
    console.log("likes", likes)
  }
  async hadledisLike() {
    this.setState({ dislike: 1 })
    let account = getAccount();
    this.setState({ dislikeStart: !this.state.dislikeStart })
    this.setState({ likeStart: false })



    let data = {
      saleaddress: this.state.saleAddress,
      walletaddress: account.toLowerCase(),
      like: 0,
      dislike: 1
    }
    var sales = await SaleLike(data)
    console.log("dislikesales", sales)

    // this.setState({ likes: sales?.data?.user?.likes })
    // console.log("sales",sales)
    let likes = sales?.data?.user?.likes
    likes?.map((val) => {
      if (val.saleaddress == this.state.saleAddress) {
        this.setState({ islike: val.islike, likeCount: sales?.data?.result?.like, dislikeCount: sales?.data?.result?.dislike })
      }
    })
    console.log("dislikes", likes)
  }

  lockDaysCal() {
    if (this.state.saleInfo.lpUnlockon == 0) {
      return 0
    }
    let diffTime = Math.abs(new Date(parseFloat(this.state.saleInfo.endTime) * 1000).getTime() - new Date(parseFloat(this.state.saleInfo.lpUnlockon) * 1000).getTime());
    let days = diffTime / (24 * 60 * 60 * 1000);
    console.log("days", days)
    return days.toFixed(0)
  }

  onDismiss() {
    this.setState({ likenotfiModal: false });
  }

  render() {

    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    // const { tokenBalance } = this.props
    const { saleInfo, userInfo, whitelistModal, removewhitelistModal, changestatueModal, userData, iswhitelisted, likenotfiModal } = this.state
    { console.log("saleinfo", saleInfo); }
    return (
      <>
        {likenotfiModal && <Likemodal connect={"string"} onDismiss={() => this.onDismiss()} />}
        <div id="loader_main">
          <div id="loader_div">
            <span className="spin_round">

            </span>
            <img src={favicon} className="logo_load" />
          </div>
          <div className='logo_overlay' id="logo_overlay">

            <Header />

            <div className="whole_sec pb-5">
              <div className='flex_side_right'>
                <Sidebar />
                {/* ongoing_sec */}
                <div className='right_side_sec'>
                  {/* <div className="text-white topBar d-flex justify-content-between">
                  
                  <small>Trending</small>
                <small>
                  #1&nbsp;<span>Husy</span>
                </small>
                <small>
                  #2&nbsp;<span>ORL</span>
                </small>
                <small>
                  #3&nbsp;<span>UWC</span>
                </small>
                <small>
                  #4&nbsp;<span>777</span>
                </small>
                <small>
                  #5&nbsp;<span>IDXS</span>
                </small>
                <small>
                  #6&nbsp;<span>COUGNU</span>
                </small>
                <small>
                  #7&nbsp;<span>CRICLE</span>
                </small>
                <small>
                  #8&nbsp;<span>KASA</span>
                </small>
                <small>
                  #9&nbsp;<span>FIFAPP</span>
                </small>
                <small>
                  #10&nbsp;<span>SOG</span>
                </small>
                <small>
                  #11&nbsp;<span>COOSHA</span>
                </small>
                <small>
                  #12&nbsp;<span>Honey</span>
                </small>
                
                
              </div> */}
                  {/* <Trendingslider/> */}
                  <div className="right_side_spacing">
                    <Container className='px-1'>
                                            <button  onClick={this.handleGoBack} className="backbtn mb-3"><i class="fa fa-arrow-left"></i>  Back</button>

                      <div className='row mt-5'>
                        <div className='col-12 col-md-6 col-lg-7 mb-4'>
                          <div className='card_bg card'>
                            <div className='position-relative detailposition'>
                              <img src={saleInfo && saleInfo?.banner} className='img-fluid detailbanner' alt='detailbanner' />
                              {saleInfo && isSaleLive(saleInfo?.startTime, saleInfo?.endTime, saleInfo?.isPresaleOpen) ?
                                <span className="badge badge-green-rect salesbtn mt-0">
                                  <span className='blk_txt d-flex align-items-center'><span className='roundclr mr-1'></span> Sales Live</span>
                                </span> : (isUpcoming(saleInfo?.startTime) ?
                                  <span className="badge badge-green-rect salesbtn mt-0">
                                    <span className='blk_txt'>Sales Upcoming</span>
                                  </span> :
                                  <span className="badge badge-green-rect salesbtn mt-0">
                                    <span className='blk_txt'>Sales Closed</span>
                                  </span>)
                              }

                            </div>
                            <div className='profimg deprof'>
                              <img src={saleInfo && saleInfo.logo} alt={saleInfo && saleInfo.symbol} className='img_ind_circle' />
                              {/* <img src="https://bscscan.com/images/svg/brands/bnb.svg?v=1.3" alt="image" className='img_ind_circle'/> */}
                            </div>
                            <div className='card-body'>

                              <div className='row mt-0 mb-4'>
                                <div className='col-md-8'>
                                  <h5 className='fname cardtitle'>{saleInfo.name}</h5>
                                  {/* <div className='d-flex mb-1'>
                                  <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
                                      <path d="M5.61701 0.678313L3.08242 3.21748C2.91284 3.38706 2.81659 3.62081 2.81659 3.86373L2.81659 8.44248C2.81659 8.94665 3.22909 9.35915 3.73326 9.35915L7.85367 9.35915C8.22034 9.35915 8.55034 9.13915 8.69242 8.80456L10.1866 5.31665C10.5762 4.40915 9.91159 3.40081 8.92617 3.40081L6.33659 3.40081L6.77201 1.30165C6.81784 1.07248 6.74909 0.83873 6.58409 0.67373C6.31367 0.407896 5.88284 0.407896 5.61701 0.678313ZM0.978674 9.35915C1.48284 9.35915 1.89534 8.94665 1.89534 8.44248L1.89534 4.77581C1.89534 4.27165 1.48284 3.85915 0.978674 3.85915C0.474508 3.85915 0.0620074 4.27165 0.0620074 4.77581L0.062007 8.44248C0.062007 8.94665 0.474507 9.35915 0.978674 9.35915Z" fill="#CD9D0D" />
                                    </svg> <span className='grnno ml-2'>1500</span></div>
                                  <div className='ml-3'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
                                      <path d="M4.88433 9.15578L7.41892 6.61661C7.5885 6.44703 7.68475 6.21328 7.68475 5.97036L7.68475 1.39161C7.68475 0.887446 7.27225 0.474946 6.76809 0.474946L2.64767 0.474945C2.281 0.474945 1.951 0.694945 1.80892 1.02953L0.314752 4.51744C-0.0748317 5.42494 0.589752 6.43328 1.57517 6.43328L4.16475 6.43328L3.72933 8.53245C3.6835 8.76161 3.75225 8.99536 3.91725 9.16036C4.18767 9.4262 4.6185 9.4262 4.88433 9.15578ZM9.52267 0.474947C9.0185 0.474947 8.606 0.887447 8.606 1.39161L8.606 5.05828C8.606 5.56245 9.0185 5.97495 9.52267 5.97495C10.0268 5.97495 10.4393 5.56245 10.4393 5.05828L10.4393 1.39161C10.4393 0.887447 10.0268 0.474947 9.52267 0.474947Z" fill="#CD9D0D" />
                                    </svg> <span className='redno ml-2'>150</span></div>
                                </div> */}
                                  <div className='d-flex mb-2 justify-content-left'>

                                    {this.state.tokenBalance > 0 ?
                                      <div className='thumpall'>
                                        <Button variant="primary"
                                          disabled={this.state.tokenBalance > 0 ? this.state.islike == true ? true : false : true}
                                          onClick={() => { this.hadleLike() }}>
                                          <FaThumbsUp className={this.state.likeStart == true ? "thumpupactive" : "thumpup"}

                                          />
                                          <span className='blueno ml-2'>{this.state.likeCount}</span>
                                        </Button>
                                      </div>
                                      :

                                      <div className='thumpall'>
                                        <Button variant="primary" onClick={() => this.setState({ likenotfiModal: true })}>
                                          <FaThumbsUp className="thumpup" />
                                          <span className='blueno ml-2'>0</span>
                                        </Button>
                                      </div>
                                    }


                                    {/* <div>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none"
                                                        onClick={()=>{this.hadleLike()}}
                                                        >
                                                            <path d="M5.61701 0.678313L3.08242 3.21748C2.91284 3.38706 2.81659 3.62081 2.81659 3.86373L2.81659 8.44248C2.81659 8.94665 3.22909 9.35915 3.73326 9.35915L7.85367 9.35915C8.22034 9.35915 8.55034 9.13915 8.69242 8.80456L10.1866 5.31665C10.5762 4.40915 9.91159 3.40081 8.92617 3.40081L6.33659 3.40081L6.77201 1.30165C6.81784 1.07248 6.74909 0.83873 6.58409 0.67373C6.31367 0.407896 5.88284 0.407896 5.61701 0.678313ZM0.978674 9.35915C1.48284 9.35915 1.89534 8.94665 1.89534 8.44248L1.89534 4.77581C1.89534 4.27165 1.48284 3.85915 0.978674 3.85915C0.474508 3.85915 0.0620074 4.27165 0.0620074 4.77581L0.062007 8.44248C0.062007 8.94665 0.474507 9.35915 0.978674 9.35915Z" fill="#CD9D0D" 
                                                            
                                                            />
                                                        </svg> <span className='grnno ml-2'>{this.state.likeCount}</span></div> */}
                                    {this.state.tokenBalance > 0 ?
                                      <div className='ml-2 thumpall'>
                                        <Button variant="primary" disabled={this.state.tokenBalance > 0 ? this.state.islike == false ? true : false : true}
                                          onClick={() => { this.hadledisLike() }}>
                                          <FaThumbsDown className={this.state.dislikeStart == true ? "thumpdownactive" : "thumpdown"} />
                                          <span className='redno ml-2'>{this.state.dislikeCount}</span>
                                        </Button>
                                      </div>
                                      :
                                      <div className='ml-3 thumpall'>
                                        <Button variant="primary" onClick={() => this.setState({ likenotfiModal: true })}>
                                          <FaThumbsDown className="thumpdown" />
                                          <span className='redno ml-2'>0</span>
                                        </Button>
                                      </div>

                                    }



                                    {/* <div className='ml-3'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none"
                                                        onClick={()=>{this.hadledisLike()}}
                                                        >
                                                            <path d="M4.88433 9.15578L7.41892 6.61661C7.5885 6.44703 7.68475 6.21328 7.68475 5.97036L7.68475 1.39161C7.68475 0.887446 7.27225 0.474946 6.76809 0.474946L2.64767 0.474945C2.281 0.474945 1.951 0.694945 1.80892 1.02953L0.314752 4.51744C-0.0748317 5.42494 0.589752 6.43328 1.57517 6.43328L4.16475 6.43328L3.72933 8.53245C3.6835 8.76161 3.75225 8.99536 3.91725 9.16036C4.18767 9.4262 4.6185 9.4262 4.88433 9.15578ZM9.52267 0.474947C9.0185 0.474947 8.606 0.887447 8.606 1.39161L8.606 5.05828C8.606 5.56245 9.0185 5.97495 9.52267 5.97495C10.0268 5.97495 10.4393 5.56245 10.4393 5.05828L10.4393 1.39161C10.4393 0.887447 10.0268 0.474947 9.52267 0.474947Z" fill="#CD9D0D" />
                                                        </svg> <span className='redno ml-2'>{this.state.dislikeCount}</span></div> */}
                                  </div>

                                  <div className='flex_badges_dv flex_badges_dv_new'>
                                    <div className='inside_soc_f'>
                                      {/* { saleInfo?.owner == localStorage.getItem("accountInfo") ?    
                   <Link to={`/launchpadedit/${this.state.saleAddress}`}  className='btn_social_new btn_social_new_link ml-2'>
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                        </Link> : <></>} */}

                                      <a target="_blank" href={saleInfo && saleInfo.social && saleInfo?.social[1]} className='btn_social_new btn_social_new_a_new ml-1'>
                                        <i class="fa fa-globe" aria-hidden="true"></i>
                                      </a>

                                      <a target="_blank" href={saleInfo && saleInfo?.social && saleInfo?.social[2]} className='btn_social_new btn_social_new_a_new ml-1'>
                                        <i class="fa fa-twitter" aria-hidden="true"></i>
                                      </a>

                                      <a target="_blank" href={saleInfo && saleInfo?.social && saleInfo?.social[7]} className='btn_social_new btn_social_new_a_new ml-1'>
                                        <i class="fa fa-paper-plane" aria-hidden="true"></i>
                                      </a>

                                      <a target="_blank" href={saleInfo && saleInfo.social && saleInfo?.social[8]} className='btn_social_new btn_social_new_a_new ml-1'>
                                        <i class="fa fa-instagram" aria-hidden="true"></i>
                                      </a>
                                      {/* </>} */}
                                    </div>

                                    {/* {this.state.auditkyc.find(e => e.saleaddress == window.location.pathname.split('/')[2]) &&
                                    <p className='text-right mb-0 ml-2'>
                                      <span className="badge badge-green-rect mt-0 mr-2">
                                        <a className='blk_txt text_in_badge_a' href={this.state.singleaudit.audit} target="_blank">Audit</a>
                                      </span>
                                      <span className="badge badge-kyc-rect mt-0">
                                        <a className='blk_txt text_in_badge_a' href={this.state.singleaudit.kyc} target="_blank">KYC</a>
                                      </span>
                                    </p>
                                  } */}
                                  </div>
                                </div>
                                {this.state.auditkyc.find(e => e.saleaddress == window.location.pathname.split('/')[2]) &&
                                  <div className='col-md-4'>
                                    <div className='d-flex'>
                                      {!isEmpty(this.state.singleaudit.audit) ? <a className='blk_txt text_in_badge_a' href={this.state.singleaudit.audit} target="_blank"><p className='audit mb-0'>Audit</p></a> : ""}
                                      {!isEmpty(this.state.singleaudit.kyc) ? <a className='blk_txt text_in_badge_a' href={this.state.singleaudit.kyc} target="_blank"><p className='audit mb-0 ml-2'>KYC +</p></a> : ""}
                                    </div>
                                  </div>
                                }
                              </div>


                              {/* <span class="badge badge-kyc-rect mt-0 mb-2 badge_trend_detail"><span class="blk_txt">#Ontop {}</span></span> */}
                              {/* {this.state.singletrending && <span class="badge badge-kyc-rect mt-0 mb-2 badge_trend_detail"><span class="blk_txt">#OnTop{this.state.singletrending?.position}</span></span>} */}


                              {/* <div className='row align-items-center pb-4 row_left_res row_left_res_new'>
                <div className='col-12 col-sm-7 col-md-12 col-xl-9 mb-3 mb-md-0'>
                <div className='d-flex align-items-center fklex_dircol flex_mob_blk_div align_col_bkk'>
                    <div className='d-flex align-items-center'>             
                   </div>
                   <div>
                   <div className='flex_badges_dv flex_badges_dv_new'>
                   <div className='inside_soc_f'>
                { saleInfo?.owner == localStorage.getItem("accountInfo") ?    
                   <Link to={`/launchpadedit/${this.state.saleAddress}`}  className='btn_social_new btn_social_new_link ml-2'>
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                        </Link> : <></>}
                                     
                        <a target="_blank" href={saleInfo && saleInfo.social && saleInfo?.social[1]} className='btn_social_new btn_social_new_a_new ml-1'>
<i class="fa fa-globe" aria-hidden="true"></i>
</a>

<a target="_blank" href={saleInfo && saleInfo?.social && saleInfo?.social[2]} className='btn_social_new btn_social_new_a_new ml-1'>
<i class="fa fa-twitter" aria-hidden="true"></i>
</a>

<a target="_blank" href={saleInfo && saleInfo?.social && saleInfo?.social[7]} className='btn_social_new btn_social_new_a_new ml-1'>
<i class="fa fa-paper-plane" aria-hidden="true"></i>
</a>

<a  target="_blank" href={saleInfo && saleInfo.social && saleInfo?.social[8]}  className='btn_social_new btn_social_new_a_new ml-1'>
<i class="fa fa-instagram" aria-hidden="true"></i>
</a>
</div>
                        {this.state.auditkyc.find(e => e.saleaddress == window.location.pathname.split('/')[2]) &&
                      <p className='text-right mb-0 ml-2'>
                        <span className="badge badge-green-rect mt-0 mr-2">
                        <a  className='blk_txt text_in_badge_a' href={this.state.singleaudit.audit} target = "_blank">Audit</a>
                        </span>
                        <span className="badge badge-kyc-rect mt-0">
                        <a className='blk_txt text_in_badge_a' href={this.state.singleaudit.kyc} target = "_blank">KYC</a>
                        </span>
                    </p>
                      } 
                    </div>
                   </div>
                        
                </div>
                        
                </div>
                <div className='col-12 col-sm-5 col-md-12 col-xl-3 mb-3 mb-md-0'>                                               
                    <p className='text-right-res-new'>                                    
                    </p>
                    </div>           
              </div> */}



                              <div className='mt-3'>
                                <p className='detailtext mb-4'>{saleInfo.description}
                                  <br></br>
                                  {/* Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
<br></br>
Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia */}
                                </p>

                                <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                  <span className='desc_grey_txt private_sal_size_new'>Private Sale Address</span>
                                  <span className='desc_grey_txt font_12'><a href={`${CHAINS[getChainId()].Testnet}${this.state.saleAddress}`} target='_blank' className='desc_grey_txt font_12 a_brk_new'>{this?.state?.saleAddress}</a></span>
                                </p>

                                <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                  <span className='desc_grey_txt'>1 {this.state.buyToken ? this.state.buyToken : "LUMINA"}</span>
                                  <span className='desc_grey_txt font_12'>{saleInfo && saleInfo.presaleRate} {saleInfo && saleInfo.symbol}
                                  </span>
                                </p>

                                <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                  <span className='desc_grey_txt'>Softcap</span>
                                  <span className='desc_grey_txt font_12'>{saleInfo && (parseInt(saleInfo?.softCap) / 10 ** 18).toFixed(2)} {this?.state?.buyToken}
                                  </span>
                                </p>

                                <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                  <span className='desc_grey_txt'>Hardcap</span>
                                  <span className='desc_grey_txt font_12'>{saleInfo && (parseInt(saleInfo?.hardCap) / 10 ** 18).toFixed(2)} {this?.state?.buyToken}
                                  </span>
                                </p>

                                {/* {!window.location.pathname.split('/')[3] || window.location.pathname.split('/')[3] == "false" ?  */}
                                <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                  <span className='desc_grey_txt'>Start Time</span>
                                  <span className='desc_grey_txt font_12'>{saleInfo && padToDigits(new Date(saleInfo.startTime * 1000).toLocaleDateString()) + "  "
                                    + padToDigits(new Date(saleInfo.startTime * 1000).getHours()) + ":" + padToDigits(new Date(saleInfo.startTime * 1000).getMinutes()) + ":"
                                    + padToDigits(new Date(saleInfo.startTime * 1000).getSeconds()) + "(GMT)"}
                                  </span>
                                </p>
                                {/* // : <p className='white_txt_sm d-flex justify-content-between mt-0 mb-1'>
            // <span className='desc_grey_txt'>Start Time :</span>
            // <span className='desc_grey_txt font_12'>{saleInfo && new Date(saleInfo.startTime).toLocaleDateString()+"  "
            //  +new Date(saleInfo.startTime).getHours()+":"+new Date(saleInfo.startTime).getMinutes()+":"
            //  +new Date(saleInfo.startTime).getSeconds()+"(GMT)"  }
            // </span>
            // </p>}    */}

                                {/* {!window.location.pathname.split('/')[3] || window.location.pathname.split('/')[3] == "false"? */}

                                <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                  <span className='desc_grey_txt'>End Time</span>
                                  <span className='desc_grey_txt font_12'>{saleInfo && padToDigits(new Date(saleInfo.endTime * 1000).toLocaleDateString()) + "  "
                                    + padToDigits(new Date(saleInfo.endTime * 1000).getHours()) + ":" + padToDigits(new Date(saleInfo.endTime * 1000).getMinutes()) + ":"
                                    + padToDigits(new Date(saleInfo.endTime * 1000).getSeconds()) + "(GMT)"}
                                  </span>
                                </p>
                                {/* :  <p className='white_txt_sm d-flex justify-content-between mt-0 mb-1'>
            <span className='desc_grey_txt'>End Time :</span>
            <span className='desc_grey_txt font_12'>{saleInfo && new Date(saleInfo.endTime).toLocaleDateString()+"  "
             +new Date(saleInfo.endTime).getHours()+":"+new Date(saleInfo.endTime).getMinutes()+":"
             +new Date(saleInfo.endTime).getSeconds()+"(GMT)" }
            </span>
            </p>}          */}



                                {/* <p className='white_txt_sm d-flex justify-content-between mt-0 mb-1'>
            <span className='desc_grey_txt'>First Release for Project :</span>
            <span className='desc_grey_txt font_12'>30%
            </span>
            </p>   */}

                                <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                  <span className='desc_grey_txt'>Vesting Claim</span>
                                  <span className='desc_grey_txt font_12'> {saleInfo && saleInfo.isVested ? 'Enabled' : 'Disabled'}
                                  </span>
                                </p>
                                <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                  <span className='desc_grey_txt'>LuminaExchange Listing</span>
                                  <span className='desc_grey_txt font_12'> {saleInfo && saleInfo.isPancake ? 'Enabled' : 'Disabled'}
                                  </span>
                                </p>

                                {saleInfo.isPancake ?
                                  <>
                                    <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                      <span className='desc_grey_txt'>LuminaExchange Rate</span>
                                      <span className='desc_grey_txt font_12'> {saleInfo && saleInfo?.pancakeRate}
                                      </span>
                                    </p>

                                    <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                      <span className='desc_grey_txt'>Liquidity Lockup Time</span>
                                      <span className='desc_grey_txt font_12'>  {saleInfo && this.state.isSaleEnd == true || saleInfo?.isClaimable == false ?
                                        (saleInfo?.lpUnlockon * 1000) / (1000 * 60 * 60 * 24) : this.lockDaysCal()} Days
                                      </span>


                                    </p>
                                  </> :
                                  <></>}
                                {saleInfo && saleInfo.isVested ?
                                  <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                    <span className='desc_grey_txt'>Vesting for Project</span>
                                    <span className='desc_grey_txt font_12'>{saleInfo && saleInfo.vestingPercent / 100} % each {saleInfo && saleInfo.vestingInterval / ONEDAYINSECONDS} Day(s)
                                    </span>
                                  </p> : <></>}

                                <ReactPlayer
                                  url={saleInfo && saleInfo?.social && saleInfo?.social[9]}
                                  controls={true}
                                  width="100%"
                                  height="330px"
                                />

                                {/* <p className='white_txt_sm d-flex justify-content-between mt-0 mb-1'>
            <span className='desc_grey_txt'>Vesting for Project :</span>
            <span className='desc_grey_txt font_12'>5% each 20 minutes
            </span>
            </p>   */}


                                {/* <div className='pt-3'>
                                <iframe src='https://www.youtube.com/embed/v=0G2VxhV_gXM'
                                  frameborder='0'
                                  width="100%"
                                  height="330"
                                  allow='autoplay; encrypted-media'
                                  allowfullscreen
                                  title='video'
                                />
                              </div> */}
                                {/* <ReactPlayer
                                  url={saleInfo && saleInfo?.social && saleInfo?.social[9]}
                                  controls={true}
                                  width="100%"
                                  height="330px"
                                /> */}

                              </div>

                            </div>
                          </div>


                          <div className={saleInfo?.owner == getAccount() ? 'mb-4' : "d-none"}>
                            <div className='card_bg card mt-2'>
                              <div className={'card-body'}>
                                <p className='text-white card_head'>Owner Zone</p>
                                <hr className='hr_green' />
                                <div className='col-12 col-md-12 mb-3 px-0'>
                                  <p className='input_desc_sm'>Sale Type</p>

                                  <div className="custom-control custom-radio mb-2">
                                    <input type="radio" id="customRadio1" name="customRadio" className="custom-control-input"
                                      checked={saleInfo && saleInfo?.isWhitelisted ? false : true}
                                    />
                                    <label onClick={() => this.Handlewhitelist(false)} className="custom-control-label" for="customRadio1">Public</label>
                                  </div>

                                  <div className="custom-control custom-radio mb-2">
                                    <input type="radio" id="customRadio2" name="customRadio" className="custom-control-input"
                                      checked={saleInfo && saleInfo?.isWhitelisted ? true : false}
                                    />
                                    <label onClick={() => this.Handlewhitelist(true)} className="custom-control-label" for="customRadio2">Whitelist</label>
                                  </div>


                                </div>
                                <div className='whitelist_div'>

                                  {saleInfo && saleInfo?.isWhitelisted ?
                                    <>
                                      <button className="get-started-btn w-100 mb-2" onClick={() => this.setState({ whitelistModal: true })}>
                                        Add users to whitelist
                                      </button>
                                      <button className="get-started-btn w-100 mb-2" onClick={() => this.setState({ removewhitelistModal: true })}>
                                        Remove users from whitelist
                                      </button>

                                    </>
                                    :
                                    ""}

                                  {saleInfo && saleInfo?.isWhitelisted ?
                                    <button onClick={() => this.Handlewhitelist(false)} className="get-started-btn w-100 mb-2">
                                      Disable whitelist
                                    </button> :
                                    <button onClick={() => this.Handlewhitelist(true)} className="get-started-btn w-100 mb-2">
                                      Enable whitelist
                                    </button>}

                                </div>
                                <div className='col-12 col-md-12 mb-3 px-0'>
                                  <p className='input_desc_sm'>Pool Actions</p>
                                  <button onClick={() => this.stopSaleEvent()} className="get-started-btn w-100 mb-2"
                                    //  disabled = {!saleInfo.isPresaleOpen}
                                    disabled={!isSaleLive(saleInfo.startTime, saleInfo.endTime, saleInfo.isPresaleOpen)}
                                  >
                                    Stop Sale
                                  </button>
                                  <button className="get-started-btn w-100 mb-2"
                                    onClick={() => this.Finalisesale()}
                                    disabled={saleInfo?.isClaimable}
                                  >
                                    Finalize
                                  </button>
                                  <button onClick={() => this.withdrawToken()} className="get-started-btn w-100 mb-2"
                                  // disabled={!(((saleInfo?.hardCap / 10 ** this.state.charttokendecimal) * saleInfo?.presaleRate) >
                                  //   ((saleInfo?.hardCap / 10 ** this.state.charttokendecimal) * saleInfo?.presaleRate) - (this.state.unsoldtoken))}
                                  >
                                    Get Unsold {this.state.saleInfo?.symbol}

                                  </button>

                                  <button onClick={() => this.BNBwithdraw()} className="get-started-btn w-100 mb-2"
                                  // disabled = {this.hidewithdraw}
                                  >

                                    Withdraw {this.state.buyToken}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>



                        </div>

                        <div className='col-12 col-md-6 col-lg-5 mb-4'>

                          <div className='card_bg card mb-2'>
                            <div className='card-body launchs'>
                              <p className='mb-0 text-center'>
                                {/* <span className='whttext'>Connect Network To</span>
                              <span className='whttext ml-2'><img src={ethimg} className='ethimg' alt='img' /></span>
                              <span className='whttext tokena ml-2'>Ethereum</span> */}



                                {(localStorage.getItem("accountInfo") == null) ?
                                  <button className="get-started-btn unsetbtn mr-2" onClick={() => this.setState({ walletModal: true })}>
                                    {/* <img src={wallet_icon} className='img-fluid img_walt_hader walleticon mr-2' /> */}



                                    {/* <span className='whttext card_head'>Connect Network To</span>
                                    <span className='whttext ml-2'><img src={ethimg} className='ethimg' alt='img' /></span>
                                    <span className='whttext tokena card_head ml-2'>Avalanche</span> */}

                                    <span className='whttext card_head'>Connect Wallet</span>
                                  </button> :
                                  <span className='whttext card_head'>{CHAINS[getChainId()].NAME}</span>}



                              </p>
                            </div>
                          </div>


                          <div className='card_bg card mb-2'>
                            <div className='card-body'>
                              {/* <div className='card_footer_form'>
                                <div className='d-flex align-items-center justify-content-center'>
                                <p className='mb-0 pl-3'>Make sure the website is cryptotrading</p>
                                </div>

                            </div>   */}
                              {saleInfo && isUpcoming(saleInfo.startTime) ?
                                <>
                                  <p className='text-center sale_deta_name card_head mt-3'>Sale Starts In</p>
                                  <div className='countdown_new text-center'>
                                    {console.log("Salediffernce(saleInfo.endTime)", UpcomingDiffernce(saleInfo.startTime))}
                                    <Countdown date={Date.now() + (UpcomingDiffernce(saleInfo.startTime))} renderer={renderer} className="countdown_grey" />
                                  </div>
                                </> :

                                (saleInfo && isSaleLive(saleInfo.startTime, saleInfo.endTime, saleInfo.isPresaleOpen) ?
                                  <>
                                    <p className='text-center sale_deta_name card_head mt-3'>Sale Ends In</p>
                                    <div className='countdown_new text-center'>
                                      {console.log("Salediffernce(saleInfo.endTime)", Salediffernce(saleInfo.endTime))}
                                      <Countdown date={Date.now() + Salediffernce(saleInfo?.endTime)} renderer={renderer} className="countdown_grey" />
                                    </div>
                                  </> :
                                  <>
                                    <p className='text-center sale_deta_name mt-3'>This Launchpad has ended. You can no longer contribute</p>
                                    <div className='countdown_new text-center'>
                                      <p className='text-center sale_deta_name card_head mt-3'>Not Live</p>
                                    </div>
                                  </>)}
                              {console.log("parseInt(parseInt(saleInfo?.earnedCap)/parseInt(saleInfo?.hardCap) * 100)", saleInfo)}
                              {saleInfo?.LaunchpadType ?
                                <>
                                  <ProgressBar now={saleInfo && parseInt(parseInt(saleInfo?.earnedCap) / parseInt(saleInfo?.hardCap) * 100)} className='yellow_bar mt-3' />
                                  <p className='white_txt_sm d-flex justify-content-between mt-1'>
                                    <span className='desc_grey_txt'>{saleInfo && parseInt(parseInt(saleInfo?.earnedCap) / parseInt(saleInfo?.hardCap) * 100)} % </span>
                                    <span className='desc_grey_txt'>{saleInfo && ((saleInfo?.earnedCap) / 10 ** this.state.buyTokenDecimal).toFixed(3)}/{(parseInt(saleInfo.hardCap) / 10 ** this.state.buyTokenDecimal).toFixed(2)} {this.state.buyToken}</span>
                                  </p>
                                  {/* <p className='input_desc_sm'>Amount (Min: {saleInfo && saleInfo?.minEthLimit / 10 ** this.state.buyTokenDecimal} & Max: {saleInfo && saleInfo?.maxEthLimit / 10 ** this.state.buyTokenDecimal}  {this.state.buyToken})</p>
              <p className='input_desc_sm'>You Will Get : {this.state.claim} {this.state.saleInfo?.name}</p> */}
                                </>

                                : <>
                                  {/* <ProgressBar now={saleInfo && parseInt(parseInt(saleInfo?.earnedCap)/parseInt(saleInfo?.softCap) * 100)} className='yellow_bar mt-3'/>
<p className='white_txt_sm d-flex justify-content-between mt-1'>
<span className='desc_grey_txt'>{saleInfo && parseInt(parseInt(saleInfo?.earnedCap)/parseInt(saleInfo?.softCap) * 100)} % </span>
<span className='desc_grey_txt'>{saleInfo && ((saleInfo?.earnedCap)/10**this.state.buyTokenDecimal).toFixed(3)}/{(parseInt(saleInfo.softCap)/10**this.state.buyTokenDecimal).toFixed(2)} {this.state.buyToken}</span>
</p>             <p className='input_desc_sm'>Amount (Min: {saleInfo && saleInfo?.minEthLimit / 10 ** this.state.buyTokenDecimal} & Max: {saleInfo && saleInfo?.maxEthLimit / 10 ** this.state.buyTokenDecimal}  {this.state.buyToken})</p> */}
                                  {/* <p className='input_desc_sm'>You Will Get : {this.state.claim} {this.state.saleInfo?.name}</p> */}
                                </>}
                              {/* <p className='input_desc_sm'>You Will Get : {this.state.claim} {this.state.saleInfo?.name}</p> */}

                              {/* {this?.state?.claim} {this.state.saleInfo?.name} */}

                              {/* {!window.location.pathname.split('/')[3] || window.location.pathname.split('/')[3] == "false" &&  */}


                              <div className='mb-3'>
                                <h5 className='whttext text-center card_head mt-3 mb-3'>Contribute</h5>
                                <div className='row mt-2 align-items-end'>
                                  <div className='col-md-12 col-xl-5 col-lg-12 col-sm-6 mt-2'>
                                    <div className="inputs input-groups date_inoput_grps">
                                      <InputGroup className="datepicker_input">
                                        <FormControl id="amountmax" placeholder="0.0"
                                          aria-describedby="basic-addon2"
                                          value={this.state.amount}
                                          onChange={(e) => {
                                            var numbers = /^\d+((.)|(.\d{0,4})?)$/;
                                            if (!numbers.test(e.target.value) && e.target.value !== "") {
                                              return false
                                            }
                                            this.setState({ amount: e.target.value });
                                            this.calculateToken(e.target.value);
                                          }}
                                        />

                                      </InputGroup>
                                      <InputGroup.Append className='cur_pointer'>
                                        <button variant="outline-secondary" className="trans_cal_btn"
                                          onClick={async () => { await this.max(); await this.calculateToken(this.state.amount) }}
                                        >
                                          Max
                                        </button>
                                      </InputGroup.Append>
                                    </div>
                                  </div>
                                  <div className='col-md-12 col-xl-7 col-lg-12 col-sm-6 mt-2 atlast d-flex align-items-center'>
                                    {saleInfo.buytype ?

                                      <>
                                        {saleInfo && isSaleLive(saleInfo.startTime, saleInfo.endTime, saleInfo.isPresaleOpen) || isUpcoming(saleInfo.startTime, saleInfo.endTime) ?
                                          <button onClick={this.buy.bind(this)} disabled={saleInfo && saleInfo.isWhitelisted ? userData && !(userData.userWhitelistedAmount > 0) : false} className="get-started-btn explore-btn fontless mr-2">{saleInfo && saleInfo.isWhitelisted ? (userData && !(userData.userWhitelistedAmount > 0) ? "Not Whitelisted" : "Buy") : "Buy"} with {this.state.buyToken} </button> :
                                          // (isUpcoming(saleInfo.startTime,saleInfo.endTime) ? <button disabled={true} className="get-started-btn mr-2" > Upcoming </button> :
                                          ((!isSaleLive(saleInfo.startTime, saleInfo.endTime) ? <button disabled={true} className="get-started-btn explore-btn mr-2 approves" > Sale InActive </button> : <button onClick={this.buy.bind(this)} className="get-started-btn explore-btn mr-2 approves" > Buy </button>))
                                        }
                                      </> :



                                      <>
                                        {!this.state.approvebutton ?
                                          <button className="get-started-btn explore-btn approves mr-2" onClick={() => { this.approvetoken() }}>
                                            Approve
                                          </button> :
                                          <>
                                            {saleInfo && isSaleLive(saleInfo.startTime, saleInfo.endTime, saleInfo.isPresaleOpen) || isUpcoming(saleInfo.startTime, saleInfo.endTime) ?
                                              <button onClick={this.buy.bind(this)} disabled={saleInfo && saleInfo.isWhitelisted ? userData && !(userData.userWhitelistedAmount > 0) : false} className="get-started-btn explore-btn fontless mr-2">{saleInfo && saleInfo.isWhitelisted ? (userData && !(userData.userWhitelistedAmount > 0) ? "Not Whitelisted" : "Buy") : "Buy"} with {this.state.buyToken} </button> :
                                              // (isUpcoming(saleInfo.startTime,saleInfo.endTime) ? <button disabled={true} className="get-started-btn mr-2" > Upcoming </button> :
                                              ((!isSaleLive(saleInfo.startTime, saleInfo.endTime) ? <button disabled={true} className="get-started-btn explore-btn mr-2 approves" > Sale InActive </button> : <button onClick={this.buy.bind(this)} className="get-started-btn explore-btn mr-2 approves" > Buy </button>))
                                            }
                                          </>
                                        }</>}

                                    {/* {!window.location.pathname.split('/')[3] || window.location.pathname.split('/')[3] == "false" && <> */}
                                    {/* {saleInfo && saleInfo.isVested ?
                                      <button className="get-started-btn approves light mt-0" onClick={() => this.Claim()} disabled={!this.state.saleInfo?.isClaimable}>Vested  {this.state.saleInfo?.symbol} </button> :
                                      (saleInfo && saleInfo.isClaimable ?

                                        <button onClick={() => this.Claim()} disabled={(!saleInfo.isClaimable || userData.userClaimbale <= 0)} className="get-started-btn approves light mt-0"> Claim  {this.state.saleInfo?.symbol}  </button> :
                                        "")} */}
                                    {saleInfo && saleInfo.isVested ?
                                      <button className="get-started-btn  approves light mt-0" onClick={() => this.Claim()} disabled={!this.state.saleInfo?.isClaimable}>Vested  {this.state.saleInfo?.symbol} </button> :
                                      (saleInfo && saleInfo?.LaunchpadType == false ?
                                        <button onClick={() => this.Claim()} disabled={parseFloat(userData?.userTokenBalance) !== 0 || (userData?.userInvested * saleInfo?.presaleRate) / 10 ** saleInfo?.decimals <= 0} className="get-started-btn approves light mt-0"> Claim  {this.state.saleInfo?.symbol}  </button> :
                                        <button onClick={() => this.Claim()} disabled={(!saleInfo?.isClaimable || userData?.userClaimbale <= 0)} className="get-started-btn approves light mt-0"> Claim  {this.state.saleInfo?.symbol}  </button>

                                      )}
                                    {/* </>} */}
                                    {/* </div>} */}
                                  </div>
                                </div>
                                <p classame='desc_grey_txt'>You Will Get : {this.state.claim} {this.state.saleInfo?.name}</p>

                              </div>

                              <p className='white_txt_sm d-flex justify-content-between borbot mt-0 mb-1'>
                                <span className='desc_grey_txt'>Token Address </span>
                                <span><a href={`${CHAINS[getChainId()].Testnet}${saleInfo && saleInfo?.tokenAddress}`} target='_blank' className='desc_grey_txt font_12'>{saleInfo && saleInfo?.tokenAddress}</a></span>
                              </p>

                              <p className='white_txt_sm d-flex justify-content-between borbot mt-0 mb-1'>
                                <span className='desc_grey_txt'>Access Type</span>
                                {saleInfo && saleInfo?.isWhitelisted ?
                                  <span className='desc_grey_txt font_12'>Private</span> :


                                  <span className='desc_grey_txt font_12'>Public</span>}
                              </p>
                              <p className='white_txt_sm d-flex justify-content-between borbot mt-0 mb-1'>
                                <span className='desc_grey_txt'>Status </span>
                                {saleInfo && isSaleLive(saleInfo?.startTime, saleInfo?.endTime, saleInfo?.isPresaleOpen) ?
                                  <span className='desc_grey_txt font_12'>Live</span> :
                                  (isUpcoming(saleInfo?.startTime) ?
                                    <span className='desc_grey_txt font_12'>Upcoming</span> :
                                    <span className='desc_grey_txt font_12'>Closed</span>)}
                              </p>
                              <p className='white_txt_sm d-flex justify-content-between borbot mt-0 mb-3'>
                                <span className='desc_grey_txt'>Presale Rate </span>
                                <span className='desc_grey_txt font_12'>{saleInfo && saleInfo.presaleRate} {saleInfo && saleInfo.symbol}</span>
                              </p>

                              <p className='white_txt_sm d-flex justify-content-between borbot mt-0 mb-1'>
                                <span className='desc_grey_txt'>Minimum Buy </span>
                                <span className='desc_grey_txt font_12'>{saleInfo && (parseInt(saleInfo.minEthLimit) / 10 ** this.state.buyTokenDecimal)}  {this.state.buyToken}</span>
                              </p>
                              {console.log("minimum buy", this.state.buyTokenDecimal)}
                              <p className='white_txt_sm d-flex justify-content-between borbot mt-0 mb-1'>
                                <span className='desc_grey_txt'>Maximum Buy </span>
                                <span className='desc_grey_txt font_12'>{(saleInfo && saleInfo?.maxEthLimit / 10 ** this?.state?.buyTokenDecimal)}  {this.state.buyToken}</span>
                              </p>
                              {console.log("this?.state?.buyTokenDecimal", this?.state?.buyTokenDecimal)}
                              {/* {!window.location.pathname.split('/')[3] || window.location.pathname.split('/')[3] == "false" && */}
                              <p className='white_txt_sm d-flex justify-content-between borbot mt-0 mb-1'>
                                <span className='desc_grey_txt'>You Purchased </span>
                                {console.log("userData.userClaimbale", userData?.userClaimbale, userData?.userInvested)}
                                {/* <span className='desc_grey_txt font_12'> {userData && userData?.userInvested == undefined ? 0 : (parseInt(userData?.userInvested) / 10 ** parseInt(saleInfo.decimals)).toFixed(3)} {saleInfo && saleInfo.symbol}</span> */}
                                <span className='desc_grey_txt font_12'> {userData && userData?.userClaimbale == NaN ? 0 : (parseInt(userData?.userClaimbale) / 10 ** parseInt(saleInfo.decimals)).toFixed(2)} {saleInfo && saleInfo.symbol}</span>

                              </p>
                              {saleInfo.LaunchpadType || saleInfo.isClaimable ?
                                <p className='white_txt_sm d-flex justify-content-between borbot mt-0 mb-3'>
                                  <span className='desc_grey_txt'>AVG Contribution </span>
                                  <span className='desc_grey_txt font_12'>  {this.state.avgcontribution ? this.state.avgcontribution : "0"}</span>
                                </p> : ""}
                              <p className='white_txt_sm d-flex justify-content-between borbot mt-0 mb-3'>
                                <span className='desc_grey_txt'>Total Contributors </span>
                                <span className='desc_grey_txt font_12'> {saleInfo && saleInfo.participants}</span>
                              </p>
                              <p className='white_txt_sm d-flex justify-content-between borbot mt-0 mb-3'>
                                <span className='desc_grey_txt'>My Contribution </span>
                                <span className='desc_grey_txt font_12'> {userData && Number(userData.userInvested) / 10 ** 18} {this.state.buyToken}</span>
                              </p>



                              {/* } */}
                              {/* {console.log("!window.location.pathname.split('/')[3]" , window.location.pathname.split('/')[3])} */}
                              {/* { saleInfo && isSaleLive(saleInfo.startTime,saleInfo.endTime,saleInfo.isPresaleOpen) || isUpcoming(saleInfo.startTime,saleInfo.endTime) ? 
                    <button onClick={this.buy.bind(this)}disabled={ saleInfo && saleInfo.isWhitelisted ? userData && !(userData.userWhitelistedAmount > 0) : false } className="get-started-btn">{saleInfo && saleInfo.isWhitelisted ? (userData && !(userData.userWhitelistedAmount > 0) ? "Not Whitelisted" : "Buy"):"Buy"} with {this.state.buyToken} </button>:
                    // (isUpcoming(saleInfo.startTime,saleInfo.endTime) ? <button disabled={true} className="get-started-btn mr-2" > Upcoming </button> :
                    ((!isSaleLive(saleInfo.startTime,saleInfo.endTime) ?<button disabled={true} className="get-started-btn mr-2" > Sale InActive </button>:<button onClick={this.buy.bind(this)} className="get-started-btn" > Buy </button>))
                    } */}

                              {/* {!window.location.pathname.split('/')[3] || window.location.pathname.split('/')[3] == "false" && <div> */}

                            </div>
                          </div>

                          <div className='card_bg card mb-2'> 
                            <div className='card-body pt-2'>
                              {saleInfo?.LaunchpadType && <><p className='text-white text-center card_head mt-4'>Token Metrics</p>
                                {console.log("[((saleInfo?.hardCap/10**this.state.charttokendecimal) * saleInfo?.presaleRate) , ((saleInfo?.hardCap/10**this.state.charttokendecimal) * saleInfo?.presaleRate)-(this.state.unsoldtoken) , this.state.unsoldtoken , this.state.liqtoken]", [((saleInfo?.hardCap / 10 ** this.state.charttokendecimal) * saleInfo?.presaleRate),
                                ((saleInfo?.hardCap / 10 ** this.state.charttokendecimal) * saleInfo?.presaleRate) - (this.state.unsoldtoken), this.state.unsoldtoken, this.state.liqtoken])}
                                {this.state.chartstatus && <Chart options={this.state.options}
                                  series={(((saleInfo?.hardCap / 10 ** this.state.charttokendecimal) * saleInfo?.presaleRate) - (this.state.unsoldtoken)) > 0 ?

                                    [((saleInfo?.hardCap / 10 ** this.state.charttokendecimal) * saleInfo?.presaleRate),

                                    ((saleInfo?.hardCap / 10 ** this.state.charttokendecimal) * saleInfo?.presaleRate) - (this.state.unsoldtoken),
                                    this.state.unsoldtoken,
                                    this.state.liqtoken] : [100, 0, 0, 0, 0]}
                                  className="chart_donut_res" type="donut" />}</>}

                                 {!this.state.chartstatus && saleInfo?.LaunchpadType && <p className='pt-4'></p> }


                                <div className='row legendall'>
                                    <div className='col-sm-6 col-md-12 col-lg-6 mt-3'>
                                      <div className="legend-item">
                                         <span className="legend-color total"></span>
                                        <div>
                                         <p className='mb-1'>Total Tokens</p>
                                        <p className='mb-0 legendcount'>{((saleInfo?.hardCap / 10 ** this.state.charttokendecimal) * saleInfo?.presaleRate).toLocaleString()}</p>
                                        </div>
                                       
                                      </div>
                                      
                                    </div>
                                    {this.state.chartstatus &&
                                    <>
                                    <div className='col-sm-6 col-md-12 col-lg-6 mt-3'>
                                      <div className="legend-item">
                                         <span className="legend-color sold"></span>
                                        <div>
                                          {console.log("gfhafas",saleInfo?.hardCap,this.state.charttokendecimal,saleInfo?.presaleRate,this.state.unsoldtoken)}
                                         <p className='mb-1'>Sold Tokens</p>
                                        <p className='mb-0 legendcount'>{this.numberChange(((saleInfo?.hardCap / 10 ** this.state.charttokendecimal) * saleInfo?.presaleRate) - this.state.unsoldtoken).toLocaleString()}</p>
                                        </div>                                       
                                      </div>             
                                    </div>
                                     <div className='col-sm-6 col-md-12 col-lg-6 mt-3'>
                                      <div className="legend-item">
                                         <span className="legend-color unsold"></span>
                                        <div>
                                         <p className='mb-1'>Unsold Tokens</p>
                                        <p className='mb-0 legendcount'>{this.numberChange(this.state.unsoldtoken)}</p>
                                        </div>
                                      </div>
              
                                    </div>
                                     <div className='col-sm-6 col-md-12 col-lg-6 mt-3'>
                                      <div className="legend-item">
                                         <span className="legend-color liquidity"></span>
                                        <div>
                                         <p className='mb-1'>Liquidity Tokens</p>
                                        <p className='mb-0 legendcount'>{this.numberChange(this.state.liqtoken)}</p>
                                        </div>
                                       
                                      </div>
              
                                    </div>
                                    </>}
                                  </div>  




                              <p className='white_txt_sm d-flex justify-content-between mt-2 mb-3'>
                                <span className='desc_grey_txt'>Lock Address </span>
                                <span className='desc_grey_txt tokena font_12'><a href={`${CHAINS[getChainId()].Testnet}${this.state.saleAddress}`} target='_blank' className='desc_grey_txt font_12 a_brk_new'>{this?.state?.saleAddress}</a></span>
                              </p>

                              <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                <span className='desc_grey_txt'>{saleInfo.liquidityPercent}%</span>
                                <span className='desc_grey_txt font_12'>{saleInfo && this.state.isSaleEnd == true || saleInfo?.isClaimable == false ?
                                  (saleInfo?.lpUnlockon * 1000) / (1000 * 60 * 60 * 24) : this.lockDaysCal()} Days</span>
                              </p>
                            </div>
                          </div>




                          {this.state?.AffliateInfo && this.state?.AffliateInfo?.[0] !== "0" ?
                            <div className='card_bg card mb-2'>
                              <div className='card-body'>
                                <h5 className='whttext card_head mb-3'>Affiliate Programs</h5>
                                <p className='white_txt_sm d-flex justify-content-between mt-2 mb-3'>
                                  <span className='desc_grey_txt'>Your Affiliate Link </span>
                                  {(localStorage.getItem("accountInfo") == null) || (localStorage.getItem("accountInfo") == "") ?
                                    <a onClick={() => this.setState({ walletModal: true })} href="javascript:void(0)" className='desc_grey_txt desc_grey_txt_link_a font_12'>
                                      Connect Wallet
                                    </a>
                                    :
                                    <CopyToClipboard text={`${frontendurl}/privatesaledetail/${this.state.saleAddress}/${localStorage.getItem("accountInfo")}`} onCopy={() => this.copyCode('invite link', `${frontendurl}/privatesaledetail/${this.state.saleAddress}/${localStorage.getItem("accountInfo")}`)}>
                                      <button variant='link' style={{ backgroundColor: "transparent", border: 0 }} className='desc_grey_txt desc_grey_txt_link_a font_12 copy_aff_btn_eft'>
                                        <span>Copy Affiliate Link</span>
                                        <i className='fa fa-copy ml-2' />
                                      </button>
                                    </CopyToClipboard>
                                  }
                                  {/* <span className='desc_grey_txt tokena font_12'>Connect Wallet</span> */}
                                </p>
                                <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                  <span className='desc_grey_txt'>Pool Reference </span>
                                  <span className='desc_grey_txt font_12'>{Number(this.state.getChildren?.length) > 0 ? this.state.getChildren?.length : 0}</span>
                                </p>
                                <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                  <span className='desc_grey_txt'>Affiliate Percentage </span>
                                  {console.log("this.state.AffliateInfo[0]", this.state.AffliateInfo[0])}
                                  <span className='desc_grey_txt font_12'>{this.state.AffliateInfo[0] == undefined ? 0 : parseFloat(this.state.AffliateInfo[0]) / 10 ** 18} %</span>

                                </p>


                                {/* <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                              <span className='desc_grey_txt'>Min Reward </span>
                              <span className='desc_grey_txt font_12'>{this.state.AffliateInfo[1] / 10 ** this.state.buyTokenDecimal.toFixed(0)}  {this.state.buyToken}</span>
                            </p>
                            <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                              <span className='desc_grey_txt'>Max Reward </span>
                              <span className='desc_grey_txt font_12'>{this.state.AffliateInfo[2] / 10 ** this.state.buyTokenDecimal.toFixed(0)}  {this.state.buyToken}</span>
                            </p> */}
                                {/* <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                              <span className='desc_grey_txt'>Total Reward Paid </span>
                              <span className='desc_grey_txt font_12'>100000 USDT</span>
                            </p> */}
                              </div>
                            </div> : ""}

                          <div className={saleInfo?.owner == getAccount() && Number(this.state.getChildren?.length) > 0 ? 'card_bg card mt-2 mb-2' : 'd-none'}>
                            <div className='card-body'>
                              <p className='affiliate_progrma_tilte whtclrr card_head'>Affiliates</p>
                              <div className='overflow_table_Ver'>
                                <div className='table-responsive'>
                                  <table className='table affilair_table'>
                                    <thead>
                                      <tr>
                                        {/* <th></th> */}
                                        <th>S.No</th>
                                        <th>Affiliate Wallet Address</th>
                                        {/* <th>Rewards Paid</th> */}
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {Number(this.state.getChildren?.length) > 0 && this.state.getChildren && this.state.getChildren?.map((item, index) => {
                                        return (

                                          < tr >
                                            {/* <td></td> */}
                                            <td>{index == 0 ? 1 : index + 1}</td>
                                            <td>{item}</td>


                                          </tr>
                                        )
                                      })}

                                    </tbody>
                                  </table>
                                </div>
                              </div>

                            </div>
                          </div>


                          <div className='card_bg card mb-2'>
                            <div className='card-body'>
                              {/* <h5 className='whttext mb-3'>GoPlus Security</h5>
                            <p className='white_txt_sm d-flex justify-content-between mt-2 mb-3'>
                              <span className='desc_grey_txt'>Contract Verfied </span>
                              <span className='desc_grey_txt tokena font_12'>true</span>
                            </p>
                            <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                              <span className='desc_grey_txt'>Buy Tax </span>
                              <span className='desc_grey_txt tokena font_12'>0 %</span>
                            </p>
                            <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                              <span className='desc_grey_txt'>Sell Tax </span>
                              <span className='desc_grey_txt tokena font_12'>0 %</span>
                            </p>
                            <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                              <span className='desc_grey_txt'>Mintable </span>
                              <span className='desc_grey_txt tokena font_12'>false</span>
                            </p>
                            <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                              <span className='desc_grey_txt'>Transfer Pausable </span>
                              <span className='desc_grey_txt tokena font_12'>false</span>
                            </p>
                            <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                              <span className='desc_grey_txt'>Blacklist </span>
                              <span className='desc_grey_txt tokena font_12'>false</span>
                            </p> */}
                              {console.log("saleInfo?.isClaimable", saleInfo?.isClaimable)}
                              <h5 className='whttext card_head mb-3'>DEX Listing</h5>
                              <p className='white_txt_sm d-flex justify-content-between mt-2 mb-3'>
                                <span className='desc_grey_txt'>Listed On</span>
                                <span className='desc_grey_txt tokena font_12'>
                                  <a href={saleInfo?.isClaimable ? `https://pancakeswap.finance/swap?outputCurrency=/${saleInfo && saleInfo?.tokenAddress}` : "https://pancakeswap.finance/swap?outputCurrency="} target={'_blank'} className="tokena">
                                    <img src={logo1} className="dex_list_img" />
                                    <span>PancakeSwap</span>
                                  </a>
                                </span>
                              </p>
                              <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                <span className='desc_grey_txt'>Chart</span>
                                <span className='desc_grey_txt tokena font_12'>
                                  <a href={saleInfo?.isClaimable ? `https://poocoin.app/tokens/${saleInfo && saleInfo?.tokenAddress}` : "https://poocoin.app/tokens/"} target={'_blank'} className="tokena">
                                    <img src={logo2} className="dex_list_img" />
                                    <span>Poocoin</span>
                                  </a>
                                </span>
                              </p>
                              <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                <span className='desc_grey_txt'>Chart</span>
                                <span className='desc_grey_txt tokena font_12'>
                                  <a href={saleInfo?.isClaimable ? `https://dexcheck.ai/app/bsc/chart/${saleInfo && saleInfo?.tokenAddress}` : "https://dexcheck.ai/app/bsc/chart/"} target={'_blank'} className="tokena">
                                    <img src={logo3} className="dex_list_img" />
                                    <span>DexCheck</span>
                                  </a>
                                </span>
                              </p>
                              <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                <span className='desc_grey_txt'>Chart</span>
                                <span className='desc_grey_txt tokena font_12'>
                                  <a href={saleInfo?.isClaimable ? `https://ave.ai/${saleInfo && saleInfo?.tokenAddress}` : "https://ave.ai/"} target={'_blank'} className="tokena">
                                    <img src={logo4} className="dex_list_img" />
                                    <span>AVE.AI</span>
                                  </a>
                                </span>
                              </p>
                              <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                <span className='desc_grey_txt'>Chart</span>
                                <span className='desc_grey_txt tokena font_12'>
                                  <a href={saleInfo?.isClaimable ? `https://www.geckoterminal.com/bsc/pools/${saleInfo && saleInfo?.tokenAddress}` : "https://www.geckoterminal.com/bsc/pools/"} target={'_blank'} className="tokena">
                                    <img src={logo5} className="dex_list_img" />
                                    <span>GeckoTerminal</span>
                                  </a>
                                </span>
                              </p>
                              <p className='white_txt_sm d-flex justify-content-between mt-0 mb-3'>
                                <span className='desc_grey_txt'>Chart</span>
                                <span className='desc_grey_txt tokena font_12'>
                                  <a href={saleInfo?.isClaimable ? `https://app.quickintel.io/scanner/${saleInfo && saleInfo?.tokenAddress}` : "https://app.quickintel.io/scanner/"} target={'_blank'} className="tokena">
                                    <img src={logo6} className="dex_list_img" />
                                    <span>Quick Intel</span>
                                  </a>
                                </span>
                              </p>
                            </div>
                          </div>

                        </div>
                      </div>

                      {/* <div className='row'> */}
                      {/* <div className='col-12 col-md-6 col-lg-6 mb-4'>
                <div className='card_bg card h-100'>
            <div className='card-body'> */}


                      {/* {window.location.pathname.split('/')[3] && <Chart options={this.state.options} 
                   series={[((saleInfo?.hardCap/10**this.state.charttokendecimal) * saleInfo?.presaleRate) , 
                   ((saleInfo?.hardCap/10**this.state.charttokendecimal) * saleInfo?.presaleRate)-(0) , 10 , 5]}
                className="chart_donut_res" type="donut" />} */}
                      {/* </div>
                </div>
</div> */}


                      {/* <div className='card_bg card mb-2'>
  </div> */}


                      {/* <div className="custom-control custom-radio">
                    <input type="radio" id="customRadio3" name="customRadio" className="custom-control-input" />
                    <label className="custom-control-label" for="customRadio3">Public Anti-Bot</label>
                    </div>                 */}
                      {/* <button className="get-started-btn w-100 mb-2" onClick={() => this.setState({ changestatueModal: true })}>
                          Setting time to public
                        </button> */}

                      {/* <div className={saleInfo?.owner == getAccount()?'col-12 col-md-6 col-lg-6 mb-4': "d-none"}>
                <div className='card_bg card h-100'>
            <div className={'card-body' }>
                <p className='text-white'>Owner Zone</p>
                <hr className='hr_green' />
                <div className='col-12 col-md-12 mb-3 px-0'>
                        <p className='input_desc_sm'>Sale Type</p>
                      
                        <div className="custom-control custom-radio mb-2">
                    <input type="radio" id="customRadio1" name="customRadio" className="custom-control-input"
                    checked={saleInfo && saleInfo?.isWhitelisted ? false : true}
                    />
                    <label className="custom-control-label" for="customRadio1">Public</label>
                    </div>   

                    <div className="custom-control custom-radio mb-2">
                    <input type="radio" id="customRadio2" name="customRadio" className="custom-control-input"
                       checked={saleInfo && saleInfo?.isWhitelisted ? true : false}
                    />
                    <label className="custom-control-label" for="customRadio2">Whitelist</label>
                    </div>  


                        </div>
                        {this.state.iswhitelisted?
                         <div className='whitelist_div'>
                        <button className="get-started-btn w-100 mb-2" onClick={() => this.setState({ whitelistModal: true })}>
                          Add users to whitelist
                        </button>
                        <button className="get-started-btn w-100 mb-2" onClick={() => this.setState({ removewhitelistModal: true })}>
                          Remove users from whitelist
                        </button>
                       
                        {saleInfo && saleInfo?.isWhitelisted ? 
                        <button onClick={() => this.Handlewhitelist(false)} className="get-started-btn w-100 mb-2">
                          Disable whitelist
                        </button> :
                        <button onClick={() => this.Handlewhitelist(true)} className="get-started-btn w-100 mb-2">
                        Enable whitelist
                      </button>}
                      
                         </div>
                        :
                        ""}

                        <div className='col-12 col-md-12 mb-3 px-0'>
                        <p className='input_desc_sm'>Pool Actions</p>
                        <button onClick={()=> this.stopSaleEvent()}className="get-started-btn w-100 mb-2"
                        //  disabled = {!saleInfo.isPresaleOpen}
                        disabled = {!isSaleLive(saleInfo.startTime,saleInfo.endTime,saleInfo.isPresaleOpen)}
                        >
                          Stop Sale
                        </button>
                        <button className="get-started-btn w-100 mb-2" 
                        onClick={() =>this.Finalisesale()}
                        disabled = {saleInfo?.isClaimable}
                        >
                           Finalize
                        </button>
                        <button onClick={()=> this.withdrawToken()} className="get-started-btn w-100 mb-2" 
                        disabled = {!(((saleInfo?.hardCap/10**this.state.charttokendecimal) * saleInfo?.presaleRate) >
                        ((saleInfo?.hardCap/10**this.state.charttokendecimal) * saleInfo?.presaleRate)-(this.state.unsoldtoken) )}
                        >
                         Get Unsold {this.state.saleInfo?.symbol}
                         
                        </button>
                        
                        <button onClick={() => this.BNBwithdraw()} className="get-started-btn w-100 mb-2"
                        // disabled = {this.hidewithdraw}
                        >

                          Withdraw {this.state.buyToken}
                        </button> 
                        </div>
                </div>
                </div>
                </div> */}

                      {/* </div> */}





                    </Container>

                    <Container className='pb-5 px-0 mt-4'>

                      <center>
                        <small className="mt-3 bottom_text">
                          Disclaimer: The information provided shall not in any way
                          constitute a recomendation as to whether you should invest
                          in any product discussed. We accept no liability for any
                          loss occasioned to any person acting or refraining from
                          action as a result of any material provided or published.
                        </small>
                      </center>
                    </Container>
                  </div>
                </div>
              </div>
            </div>
            {whitelistModal && <WhitelistModal saleAddress={saleInfo.saleAddress} onDismiss={() => this.setState({ whitelistModal: false })} />}
            {removewhitelistModal && <RemoveWhitelistmodal saleAddress={saleInfo.saleAddress} onDismiss={() => this.setState({ removewhitelistModal: false })} />}
            {changestatueModal && <ChangeStatusmodal saleAddress={saleInfo.saleAddress} onDismiss={() => this.setState({ changestatueModal: false })} />}
          </div>
        </div>
      </>
    )
  }
}

export default PrivatesaleDetail